
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>Wiederholungstäter wird zum Beizer</h4>
    <p>
  William W. hat einen Plan. Mit der christlichen Mission, in der er verkehrt, will er ein Restaurant eröffnen. Er
  rechnet mit Einnahmen von 43’000 Franken im Monat. Diese Pläne seien «unrealistisch», findet der Bewährungshelfer, er
  mache sich Sorgen. Später spricht sich auch das Amt für Justizvollzug explizit gegen das Projekt aus. Der zuständige
  Therapeut wittert die Gefahr, dass W. finanziell scheitert und in eine Krise gerät. Ein erhöhtes Risiko für
  Sexualdelikte sei aber nicht erkennbar ‒ es bestehe kein Handlungsbedarf.
    </p>
    <p>
  Eine folgenschwere Einschätzung. Das Innendepartement beantragt kurz darauf, die Behandlung in Freiheit aufrecht zu
  erhalten. Zwar kooperiere W. nicht und umgehe die GPS-Überwachung immer wieder. Doch der Therapeut gehe von einer
  günstigen Prognose aus. Die Solothurner Staatsanwaltschaft entscheidet, noch keine Verwahrung zu beantragen. Man wolle
  zuerst ein neues Gutachten abwarten. W. umgeht die GPS-Überwachung erneut, es kommt zu zwei weiteren Ermahnungen.
    </p>
    <Image file={require('images/beiz.png')} source='W. übernimmt trotz Warnungen eine Beiz in Olten. (Facebook)' mdxType="Image" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;